angular.module('bmsApp.settings').controller('CustomerReminderSettingsCtrl', function ($scope,
																					   $q,
																					   $timeout,
																					   $filter,
																					   ReminderSvc,
																					   CustomerReminderSvc,
																					   AppSettingsSvc,
																					   notify) {

	var form = {
		validatorConfig: {
			submitHandler: function () {
				$timeout(function () {
					form.processing = true;
					self.errors = null;
					CustomerReminderSvc.scheduleSaveAll(form.data)
						.then(function (response) {
							notify({
								message: 'Settings saved'
							});
							form.data.global = response.data.global_reminder_schedule_collection;
							form.data.customers = response.data.customer_reminder_schedule_collection;
						}, function (errors) {
							self.errors = errors;
						})
						.finally(function () {
							form.processing = false;
						})
					;
				});
			},
			errorPlacement: function (error, element) {
				error.appendTo(element.parents('.reminder-schedule'));
			}
		},
		validatorApi: {},
		data: {},
		options: {
			frequency: [
				{
					value: 'hour',
					label: 'Hour(s)'
				},
				{
					value: 'day',
					label: 'Day(s)'
				},
				{
					value: 'week',
					label: 'Week(s)'
				},
				{
					value: 'month',
					label: 'Month(s)'
				}
			],
			interval: [],
			sendMethod: [
				{
					value: 'email',
					label: 'E-mail'
				},
				{
					value: 'sms',
					label: 'SMS'
				}
			]
		},
		processing: false
	};

	var self = {
		savingSettings: false,
		methods: {
			init: function () {
				var intervalOptions = [];
				for (i = 1; i <= 30; i++) {
					intervalOptions.push({
						value: i,
						label: i
					});
				}
				angular.extend(form.options.interval, intervalOptions);

				var promises = {
					schedulePromise: CustomerReminderSvc.scheduleIndex()
						.then(function (response) {
							form.data.global = response.data.global_reminder_schedule_collection;
							form.data.customers = response.data.customer_reminder_schedule_collection;
						}),
					typePromise: ReminderSvc.typeOptions()
						.then(function (response) {
							form.options.type = response.data.options;
						}),
					appSettings: AppSettingsSvc.index()
						.then(function (response) {
							$scope.appSettings = response.data.settings;
						}),
				};

				$q.all(promises)
					.then(function (responses) {

					}, function (errors) {
						self.errors = errors;
					})
					.finally(function () {
						self.loading = false;
					})
				;
			},
			saveSettings: function(){
				self.savingSettings = true;
				AppSettingsSvc.update($scope.appSettings)
					.then(function (response) {
						notify({
							message: 'Settings saved'
						});
					}, function (errors) {
						self.errors = errors;
					})
					.finally(function () {
						self.savingSettings = false;
					});
			},
			addSchedule: function (reminderSchedules, typeValue) {
				var type = $filter('filter')(form.options.type, {
					value: typeValue
				}, true)[0];
				reminderSchedules.push({
					type: type
				});
			},
			removeSchedule: function (schedule) {
				schedule.delete = true;
			},
			checkAllRemindable: function () {
				// Ignore customers who have unsubscribed
				var customerCount = $filter('filter')(form.data.customers, {unsubscribed_at: null}).length;
				var remindableCustomerCount = $filter('filter')(form.data.customers, {send_reminders: true}).length;
				self.allRemindable = customerCount === remindableCustomerCount;
				return self.allRemindable;
			},
			toggleAllRemindable: function () {
				if (self.allRemindable) {
					angular.forEach(form.data.customers, function (value) {
						value.send_reminders = false;
					});
				}
				else {
					angular.forEach(form.data.customers, function (value) {
						if (!value.unsubscribed_at) {
							value.send_reminders = true;
						}
					});
				}
			}
		},
		form: form,
		loading: true,
		errors: null
	};

	$scope.CustomerReminderSettingsCtrl = self;

});
